export const LS_KEY_PENYERTAAN = "yayasan_penyertaan";
export const LS_KEY_BUTIRAN_PENDAFTAR = "yayasan_pendaftar";
export const LS_KEY_SUMBANGAN = "yayasan_sumbangan";
export const LS_KEY_EMEL = "yayasan_emel_penyumbang";
export const LS_KEY_AGENT = "yayasan_agent";
export const LS_KEY_SEDEKAH = "yayasan_sedekah";
export const LS_KEY_ADMIN_SIGNATURE = "yayasan_admin_sig";
export const API_URL = process.env.REACT_APP_API_URL;
